import React from 'react'
import MuiDialog from '@material-ui/core/Dialog'
import Box from '@material-ui/core/Box'
import IconButton from '@material-ui/core/IconButton'
import { CloseIcon } from '~/assets/icons'
import { useIsMobileScreen } from '~/hooks'

export type DialogProps = {
  onClose: () => void,
  isVisible: boolean,
  disableClose?: boolean,
  maxWidth?: false | 'md' | 'xs' | 'sm' | 'lg' | 'xl'
}

export const Dialog: React.FC<DialogProps> = (props) => {
  const { isVisible, onClose, disableClose, maxWidth, children } = props
  const isMobile = useIsMobileScreen()

  return (
    <MuiDialog open={isVisible} onClose={onClose} maxWidth={maxWidth || 'md'}>
      <Box sx={{ padding: 1, display: 'flex', justifyContent: 'flex-end' }}>
        <IconButton disabled={disableClose} onClick={onClose}><CloseIcon /></IconButton>
      </Box>
      <Box sx={{
        display: 'flex',
        paddingLeft: isMobile ? 2 : 4,
        paddingRight: isMobile ? 2 : 4,
        paddingBottom: 4,
        alignItems: 'center',
        flexDirection: 'column',
        justifyContent: 'center'
      }}>
        {children}
      </Box>
    </MuiDialog>
  )
}
